import { format } from '@utils/string';
import { getNewShelvesMenuURL } from '@services/urls/apiGatewayURLs';

import { CATEGORY_TYPES } from '@shared/constants';
import { flattenMenuGridCategories } from '@utils/shopDetails/index';
import ServiceResponse from '../models/ServiceResponse';

const message = 'shopId param is required';

async function getSectionsList({ axios, shopId }) {
  try {
    if (!shopId) return new ServiceResponse({ error: message });

    const url = format(getNewShelvesMenuURL, shopId);

    const { data } = await axios.get(url);

    if (data.type) {
      if (data.type === CATEGORY_TYPES.TREE) {
        return new ServiceResponse({
          data: {
            categories: data.categories
              .map(flattenMenuGridCategories)
              .filter(Boolean),
            type: data.type,
          },
        });
      }

      return new ServiceResponse({
        data: {
          categories: data.categories?.map(c => ({
            ...c,
            products: [],
            globalId: c.global_id,
          })),
          type: data.type,
        },
      });
    }

    return new ServiceResponse({ data });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default getSectionsList;
